/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('Incentives.title') }}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content id="events" color="primary" forceOverscroll="false">
      <div class="mc-white-container">
        <div class="ion-text-center ion-margin-top" v-if="loading">
          <ion-icon size="large" color="primary" class="rotating" name="sync"></ion-icon>
        </div>

        <div v-if="!loading && incentive" class="mb-15">
          <h3>{{incentive.title}}</h3>
          <div v-html="incentive.description"></div>
          <ion-button class="ion-margin-top" v-if="incentive.subscriptionLink" @click="goToSubscriptionLink()" expand="block" color="primary">{{ $t('Incentives.init')}}</ion-button>
        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">

</style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";
import {InAppBrowser} from "@awesome-cordova-plugins/in-app-browser";
import {isPlatform} from "@ionic/core";

export default {
  name: "incentive",
  mixins: [toast],
  data() {
    return {
      loading: false,
      incentive: null,
      eventId: null
    };
  },
  created() {

  },
  mounted() {
    this.eventId = this.$route.params.id;
    this.getIncentive()
  },
  methods: {
    getIncentive() {
      this.loading = true;
      this.$store.dispatch("incentive", this.eventId ).then(resp => {
          this.incentive = resp
          this.loading = false;
        }).catch(error => {
          this.presentToast(this.$t("Commons.error"), "danger");
          this.loading = false;
        });
    },
    goToSubscriptionLink() {
      const uri = this.incentive.subscriptionLink
      if (isPlatform(window.document.defaultView, "capacitor")) {
        InAppBrowser.create(uri, '_system');
      } else {
        window.open(uri, '_blank');
      }
    },

  }
};
</script>
